import Logo from "../../assets/images/logo-main.png";

const ShowBoxes = (props) => {
    const box1 = [];
    const box2 = [];
    const box3 = [];


    if (props != null && props.boxes != null && props.boxes.length != 0) {
        props.boxes.sort((a, b) => parseInt(a.serial) - parseInt(b.serial));
        for (var i = 1; i <= 25; i++) {
            if (i < 10) {
                box1.push(
                    props.boxes.filter(b => b.serial == i) != null && props.boxes.filter(b => b.serial == i).length != 0 ?
                        props.boxes.filter(b => b.serial == i)[0] :
                        ""
                    ,
                );
            } else if (i < 17) {
                box2.push(
                    props.boxes.filter(b => b.serial == i) != null && props.boxes.filter(b => b.serial == i).length != 0 ?
                        props.boxes.filter(b => b.serial == i)[0] :
                        ""
                    ,
                );
            } else if (i < 26) {
                box3.push(
                    props.boxes.filter(b => b.serial == i) != null && props.boxes.filter(b => b.serial == i).length != 0 ?
                        props.boxes.filter(b => b.serial == i)[0] :
                        ""
                    ,
                );
            }
        }
    }
    var box2desktop = 0;
    return (
        <div className="row justify-content-center" dir="ltr">
            <div className="col-4">
                {box1.map(l => {
                    return (
                        <div className="row p-2">
                            <div className="lckr-col">
                                <div className='col-12 p-0 text-center' onClick={(event) => props.boxClicked(event, l.id)}>
                                    سریال: {l.serial}
                                </div>
                            </div>
                        </div>
                    )
                })
                }
            </div>
            <div className="col-4">
                {box2.map(l => {
                    box2desktop++;

                    return (
                        <span>
                            {box2desktop === 3 ?
                                <span>
                                    <div className="row pr-2 pl-2">
                                        <div className="empty-lck">
                                            <div className="empty-lck-cntnt">
                                                <div className="empty-lck-text">
                                                    <img src={Logo} width="180px" className="desk-only" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row p-2">
                                        <div className="lckr-col">
                                            <div className='col-12 p-0 text-center' onClick={(event) => props.boxClicked(event, l.id)}>
                                                سریال: {l.serial}
                                            </div>
                                        </div>
                                    </div>
                                </span>
                                :
                                <div className="row p-2">
                                    <div className="lckr-col">
                                        <div className='col-12 text-center' onClick={(event) => props.boxClicked(event, l.id)}>
                                            سریال: {l.serial}
                                        </div>
                                    </div>
                                </div>

                            }
                        </span>
                    )
                })
                }
            </div>
            <div className="col-4">
                {box3.map(l => {
                    return (
                        <div className="row p-2">
                            <div className="lckr-col">

                                <div className='col-12 text-center' onClick={(event) => props.boxClicked(event, l.id)}>
                                    سریال: {l.serial}
                                </div>
                            </div>
                        </div>
                    )
                })
                }
            </div>

        </div>
    )
}
export default ShowBoxes;